function donateModalInit() {
  const modalContainer = document.getElementById('js-donate-modal');
  
  if (modalContainer !== null) {
    const donateModal = new bootstrap.Modal(modalContainer, { backdrop: 'static', keyboard: false });
    setInterval(function(){ donateModal.show() },30000);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const consent = localStorage.getItem("cookie_consent");
  
  if (consent === 'true') {
    donateModalInit()
  }
 
}, false);
